var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      height: "600px"
    },
    attrs: {
      id: "Test"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    attrs: {
      options: _vm.quillOption
    },
    on: {
      change: _vm.onEditorChange
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };